import moment from 'moment';

export const settings = {
	// Live URL
	baseUrl: 'https://api.maxremind.technology',
	// TFS URL ( local )
	// baseUrl: 'https://api.maxremind.technology:8003',
	guestToken: 'b72f2c60cfc021b822415c72b06f201ba32fa26b', // Guest token for public repositories.
	testApi: '/api/v1/mxchuser/test/',
	refreshToken: '/api/v1/mxchuser/token/refresh/',
	mxchuser: {
		register: '/api/v1/mxchuser/register/',
		login: '/api/v1/mxchuser/login/',
		logout: '/api/v1/mxchuser/logout/',
		verifyEmail: '/api/v1/mxchuser/verify-email/',
		resendCode: '/api/v1/mxchuser/resend-code/',
		forgotPassword: '/api/v1/mxchuser/forgot-password/',
		updateUser: '/api/v1/mxchuser/update/',
		getUser: '/api/v1/mxchuser/userdata/',
	},
	mxchapp: {
		aboutUs: '/api/v1/mxchapp/aboutus',
		advertise: '/api/v1/mxchapp/advertise',
		contactUs: '/api/v1/mxchapp/contactus',
		feedback: '/api/v1/mxchapp/feedback',
		keyValues: '/api/v1/mxchapp/keyvalues',
	},
	mxchimpexp: {
		maximusExport: '/api/v1/mxchimpexp/maximusexport',
		emrExport: '/api/v1/mxchimpexp/maxemrexport',
		maximusImport: '/api/v1/mxchimpexp/maximusimport',
		maxEmrImport: '/api/v1/mxchimpexp/maxemrimport',
	},
	mxchmaster: {
		dashboardSummary: '/api/v1/mxchmaster/dashboardsummary',
		location: '/api/v1/mxchmaster/location/',
		getLocById: '/api/v1/mxchmaster/location/{id}/',
		createLoc: '/api/v1/mxchmaster/location/',
		updateLoc: '/api/v1/mxchmaster/location/',
		deleteLoc: '/api/v1/mxchmaster/location/{id}/',
		addMessage: '/api/v1/mxchmaster/message/',
		getMessages: '/api/v1/mxchmaster/message/',
		getMsgById: '/api/v1/mxchmaster/message/{id}/',
		updateMsg: '/api/v1/mxchmaster/message/{id}/',
		newPayer: '/api/v1/mxchmaster/payer/',
		getPayers: '/api/v1/mxchmaster/payer/',
		getPayerById: '/api/v1/mxchmaster/payer/{id}/',
		updatePayer: '/api/v1/mxchmaster/payer/',
		getPractices: '/api/v1/mxchmaster/practice/',
		addPractice: '/api/v1/mxchmaster/practice/',
		getPracticeById: '/api/v1/mxchmaster/practice/{id}/',
		updatePractice: '/api/v1/mxchmaster/practice/{id}/',
		addStaff: '/api/v1/mxchmaster/practicestaff/',
		getStaffs: '/api/v1/mxchmaster/practicestaff/',
		getStaffById: '/api/v1/mxchmaster/practicestaff/{id}/',
		updateStaff: '/api/v1/mxchmaster/practicestaff/',
		assignPractice: '/api/v1/mxchmaster/userpractice/',
		getUserAssignPractices: '/api/v1/mxchmaster/userpractice/',
		getUserAssignPracticesById: '/api/v1/mxchmaster/userpractice/{id}/',
		updateUserPractices: '/api/v1/mxchmaster/userpractice/{id}/',
	},
	mxchpatient: {
		addPatient: '/api/v1/mxchpatient/patient/',
		getPatients: '/api/v1/mxchpatient/patient/?practice_id',
		getPatientById: '/api/v1/mxchpatient/patient/?id',
		updatePatient: '/api/v1/mxchpatient/patient/{id}/',
		addPatientIns: '/api/v1/mxchpatient/patinsurance/',
		getPatInsurances: '/api/v1/mxchpatient/patinsurance/?patient_id',
		updatePatInsurances: '/api/v1/mxchpatient/patinsurance/{id}',
		getPatAdmissions: '/api/v1/mxchpatient/patadmission/?patient_id',
		addPatAdmission: '/api/v1/mxchpatient/patadmission/',
		getPatientLists: '/api/v1/mxchpatient/patientlist',
		getPatientWithId: '/api/v1/mxchpatient/patient/',
		updatePatientById: '/api/v1/mxchpatient/patient',
		updatePatientInsById: '/api/v1/mxchpatient/patinsurance',
		updatePatAdmByID: '/api/v1/mxchpatient/patadmission',
		getPatAdmID: '/api/v1/mxchpatient/patadmission',
		savefile: '/api/v1/mxchpatient/savefilewithpatient',
		getAdmittedPatients: '/api/v1/mxchpatient/admittedpatientlist',
		addPatnotes: '/api/v1/mxchnotes/notes/add/',
		getPatnotes:
			'/api/v1/mxchnotes/notes/?patient_id=$[patient_id]&practice_id=$[practice_id]&visit_id=$[visit_id]',
		getChargesNotes:
			'/api/v1/mxchnotes/notes/?patient_id=$[patient_id]&practice_id=$[practice_id]&visit_id=$[visit_id]',
	},
	mxchvisit: {
		addVisit: '/api/v1/mxchvisit/visit/',
		updateStatus: '/api/v1/mxchvisit/visitstatusupdate',
		getVisit: '/api/v1/mxchvisit/visit/',
		getVisitById: '/api/v1/mxchvisit/visit/',
		getAppointment: '/api/v1/mxchvisit/appointment/',
		addAppointment: '/api/v1/mxchvisit/appointment/',
		getAppointmentById: '/api/v1/mxchvisit/appointment/{id}/',
		updateAppointmentById: '/api/v1/mxchvisit/appointment/',
		getVisitAttachment: '/api/v1/mxchvisit/attachment/',
		addVisitAttachment: '/api/v1/mxchvisit/attachment/',
		getVisitAttachmentById: '/api/v1/mxchvisit/attachment/{id}/',
		updateVisitAttachment: '/api/v1/mxchvisit/attachment/{visit_id}',
		getVisitcpt: '/api/v1/mxchvisit/visitcpt/',
		getVisitWithId: 'api/v1/mxchvisit/visit/?patient_id=',
		getBatches: '/api/v1/mxchvisit/batch/',
		getVisitcpt: '/api/v1/mxchvisit/visitcpt/',
		getVisitCount: '/api/v1/mxchvisit/visitcount',
		getBatchesWithBatchID: '/api/v1/mxchvisit/batch/',
		updateBatcheWithBatchID: '/api/v1/mxchvisit/batch/',
		editVisit: '/api/v1/mxchvisit/visit/',
		savefile: '/api/v1/mxchvisit/savefile',
		postAttachment: '/api/v1/mxchvisit/attachment/',
		getVisitDataByID: '/api/v1/mxchvisit/visit/?patient_id=',
		postVisitDataList: '/api/v1/mxchvisit/visitlist',
		getVisitSummary: '/api/v1/mxchvisit/locationsummary',
	},
	mxchkb: {
		getCptCodes: '/api/v1/mxchkb/cpt/cat',
		getDxCodes: '/api/v1/mxchkb/icd/cat',
		getcptByPost: '/api/v1/mxchkb/cpt/cat',
		getDxByPost: '/api/v1/mxchkb/icd/cat',
	},
	mxchsettings: {
		getUserSettings: `/api/v1/mxchsetting/usersetting/`,
	},
};

export const gridDataTypes = ['Active', 'InActive', 'Archived'];

export const dataGridPageSizes = [10, 20, 25, 50, 100];
export const patientGridPageSizes = [
	10,
	20,
	25,
	50,
	100,
	{ label: 'All', value: 10000 },
];

export const dataGridPageSizesforReports = [
	100,
	200,
	300,
	400,
	500,
	{ label: 'All', value: 100000 },
];
export const getAccessToken = localStorage.getItem('accessToken');
// export const removeAccessToken =  localStorage.removeItem("accessToken");

export const convertUnixDate = (datetoconvert) => {
	if (datetoconvert) {
		return moment.unix(datetoconvert).format('MM-DD-YYYY [at] hh:mm a');
	}
	return '';
};

export const yupValidations = {
	nameRegex: /^[A-Za-z0-9 ]*$/,
	nameAlphabeticRegex:
		/^[A-Za-z][A-Za-z]*(([,.] |[ '-])[A-Za-z][A-Za-z]*)*(\.?)( [IVXLCDM]+)?$/,
	phoneNumberRegex: /^(\+\d{1,2}\s)?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/,
	// emailRegex: /^[A-Za-z0-9]+[-A-Za-z0-9._]*@([-A-Za-z0-9]+.)+[A-Za-z]{2,5}$/,
	emailRegex: /^[A-Za-z0-9]+[-A-Za-z0-9._]*@([-A-Za-z0-9]+[^@])+[A-Za-z]{2,5}$/,
	// /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/,
};

export const genderTypes = ['Male', 'Female', 'Not Specified'];

export const reminderFrequencies = ['Daily', 'Weekly', 'Monthly'];

export const states = [
	{ stateId: `1`, name: `Alabama`, code: `NC`, utc: `-6` },
	{ stateId: `2`, name: `Alaska`, code: `AK`, utc: `-9` },
	{ stateId: `3`, name: `Arizona`, code: `AZ`, utc: `-7` },
	{ stateId: `4`, name: `Arkansas`, code: `AR`, utc: `-6` },
	{ stateId: `5`, name: `California`, code: `CA`, utc: `-8` },
	{ stateId: `6`, name: `Colorado`, code: `CO`, utc: `-7` },
	{ stateId: `7`, name: `Connecticut`, code: `CT`, utc: `-5` },
	{ stateId: `8`, name: `Delaware`, code: `DE`, utc: `-5` },
	{ stateId: `9`, name: `Florida`, code: `FL`, utc: `-5` },
	{ stateId: `10`, name: `Georgia`, code: `GA`, utc: `-5` },
	{ stateId: `11`, name: `Hawaii`, code: `HI`, utc: `-10` },
	{ stateId: `12`, name: `Idaho`, code: `ID`, utc: `-7` },
	{ stateId: `13`, name: `Illinois`, code: `IL`, utc: `-6` },
	{ stateId: `14`, name: `Indiana`, code: `IN`, utc: `-5` },
	{ stateId: `15`, name: `Iowa`, code: `IA`, utc: `-6` },
	{ stateId: `16`, name: `Kansas`, code: `KS`, utc: `-6` },
	{ stateId: `17`, name: `Kentucky`, code: `KY`, utc: `-5` },
	{ stateId: `18`, name: `Louisiana`, code: `LA`, utc: `-6` },
	{ stateId: `19`, name: `Maine`, code: `ME`, utc: `-5` },
	{ stateId: `20`, name: `Maryland`, code: `MD`, utc: `-5` },
	{ stateId: `21`, name: `Massachusetts`, code: `MA`, utc: `-5` },
	{ stateId: `22`, name: `Michigan`, code: `MI`, utc: `-5` },
	{ stateId: `23`, name: `Minnesota`, code: `MN`, utc: `-6` },
	{ stateId: `24`, name: `Mississippi`, code: `MS`, utc: `-6` },
	{ stateId: `25`, name: `Missouri`, code: `MO`, utc: `-6` },
	{ stateId: `26`, name: `Montana`, code: `MT`, utc: `-7` },
	{ stateId: `27`, name: `Nebraska`, code: `NE`, utc: `-6` },
	{ stateId: `28`, name: `Nevada`, code: `NV`, utc: `-8` },
	{ stateId: `29`, name: `New Hampshire`, code: `NH`, utc: `-5` },
	{ stateId: `30`, name: `New Jersey`, code: `NJ`, utc: `-5` },
	{ stateId: `31`, name: `New Mexico`, code: `NM`, utc: `-7` },
	{ stateId: `32`, name: `New York`, code: `NY`, utc: `-5` },
	{ stateId: `33`, name: `North Carolina`, code: `NC`, utc: `-5` },
	{ stateId: `34`, name: `North Dakota`, code: `ND`, utc: `-6` },
	{ stateId: `35`, name: `Ohio`, code: `OH`, utc: `-5` },
	{ stateId: `36`, name: `Oklahoma`, code: `OK`, utc: `-6` },
	{ stateId: `37`, name: `Oregon`, code: `OR`, utc: `-8` },
	{ stateId: `38`, name: `Pennsylvania`, code: `PA`, utc: `-5` },
	{ stateId: `39`, name: `Rhode Island`, code: `RI`, utc: `-5` },
	{ stateId: `40`, name: `South Carolina`, code: `SC`, utc: `-5` },
	{ stateId: `41`, name: `South Dakota`, code: `SD`, utc: `-6` },
	{ stateId: `42`, name: `Tennessee`, code: `TN`, utc: `-6` },
	{ stateId: `43`, name: `Texas`, code: `TX`, utc: `-6` },
	{ stateId: `44`, name: `Utah`, code: `UT`, utc: `-7` },
	{ stateId: `45`, name: `Vermont`, code: `VT`, utc: `-5` },
	{ stateId: `46`, name: `Virginia`, code: `VA`, utc: `-5` },
	{ stateId: `47`, name: `Washington`, code: `WA`, utc: `-8` },
	{ stateId: `48`, name: `West Virginia`, code: `WV`, utc: `-5` },
	{ stateId: `49`, name: `Wisconsin`, code: `WI`, utc: `-6` },
	{ stateId: `50`, name: `Wyoming`, code: `WY`, utc: `-7` },
	{ stateId: `51`, name: `Puerto Rico`, code: `PR`, utc: `-5` },
	{ stateId: `52`, name: `Armed Forces Americas`, code: `AA`, utc: `-5` },
	{ stateId: `53`, name: `Armed Forces Europe`, code: `AE`, utc: `-5` },

	// { name: 'Alabama', code: 'AL' },
	// { name: 'Alaska', code: 'AK' },
	// { name: 'Arizona', code: 'AZ' },
	// { name: 'Arkansas', code: 'AR' },
	// { name: 'California', code: 'CA' },
	// { name: 'Colorado', code: 'CO' },
	// { name: 'Connecticut', code: 'CT' },
	// { name: 'Delaware', code: 'DE' },
	// { name: 'Florida', code: 'FL' },
	// { name: 'Georgia', code: 'GA' },
	// { name: 'Hawaii', code: 'HI' },
	// { name: 'Idaho', code: 'ID' },
	// { name: 'Illinois', code: 'IL' },
	// { name: 'Indiana', code: 'IN' },
	// { name: 'Iowa', code: 'IA' },
	// { name: 'Kansas', code: 'KS' },
	// { name: 'Kentucky', code: 'KY' },
	// { name: 'Louisiana', code: 'LA' },
	// { name: 'Maine', code: 'ME' },
	// { name: 'Maryland', code: 'MD' },
	// { name: 'Massachusetts', code: 'MA' },
	// { name: 'Michigan', code: 'MI' },
	// { name: 'Minnesota', code: 'MN' },
	// { name: 'Mississippi', code: 'MS' },
	// { name: 'Missouri', code: 'MO' },
	// { name: 'Montana', code: 'MT' },
	// { name: 'Nebraska', code: 'NE' },
	// { name: 'Nevada', code: 'NV' },
	// { name: 'New Hampshire', code: 'NH' },
	// { name: 'New Jersey', code: 'NJ' },
	// { name: 'New Mexico', code: 'NM' },
	// { name: 'New York', code: 'NY' },
	// { name: 'North Carolina', code: 'NC' },
	// { name: 'North Dakota', code: 'ND' },
	// { name: 'Ohio', code: 'OH' },
	// { name: 'Oklahoma', code: 'OK' },
	// { name: 'Oregon', code: 'OR' },
	// { name: 'Pennsylvania', code: 'PA' },
	// { name: 'Rhode Island', code: 'RI' },
	// { name: 'South Carolina', code: 'SC' },
	// { name: 'South Dakota', code: 'SD' },
	// { name: 'Tennessee', code: 'TN' },
	// { name: 'Texas', code: 'TX' },
	// { name: 'Utah', code: 'UT' },
	// { name: 'Vermont', code: 'VT' },
	// { name: 'Virginia', code: 'VA' },
	// { name: 'Washington', code: 'WA' },
	// { name: 'West Virginia', code: 'WV' },
	// { name: 'Wisconsin', code: 'WI' },
	// { name: 'Wyoming', code: 'WY' },
];

export const countries = [
	{ name: 'Afghanistan', code: 'AF' },
	{ name: 'Åland Islands', code: 'AX' },
	{ name: 'Albania', code: 'AL' },
	{ name: 'Algeria', code: 'DZ' },
	{ name: 'American Samoa', code: 'AS' },
	{ name: 'AndorrA', code: 'AD' },
	{ name: 'Angola', code: 'AO' },
	{ name: 'Anguilla', code: 'AI' },
	{ name: 'Antarctica', code: 'AQ' },
	{ name: 'Antigua and Barbuda', code: 'AG' },
	{ name: 'Argentina', code: 'AR' },
	{ name: 'Armenia', code: 'AM' },
	{ name: 'Aruba', code: 'AW' },
	{ name: 'Australia', code: 'AU' },
	{ name: 'Austria', code: 'AT' },
	{ name: 'Azerbaijan', code: 'AZ' },
	{ name: 'Bahamas', code: 'BS' },
	{ name: 'Bahrain', code: 'BH' },
	{ name: 'Bangladesh', code: 'BD' },
	{ name: 'Barbados', code: 'BB' },
	{ name: 'Belarus', code: 'BY' },
	{ name: 'Belgium', code: 'BE' },
	{ name: 'Belize', code: 'BZ' },
	{ name: 'Benin', code: 'BJ' },
	{ name: 'Bermuda', code: 'BM' },
	{ name: 'Bhutan', code: 'BT' },
	{ name: 'Bolivia', code: 'BO' },
	{ name: 'Bosnia and Herzegovina', code: 'BA' },
	{ name: 'Botswana', code: 'BW' },
	{ name: 'Bouvet Island', code: 'BV' },
	{ name: 'Brazil', code: 'BR' },
	{ name: 'British Indian Ocean Territory', code: 'IO' },
	{ name: 'Brunei Darussalam', code: 'BN' },
	{ name: 'Bulgaria', code: 'BG' },
	{ name: 'Burkina Faso', code: 'BF' },
	{ name: 'Burundi', code: 'BI' },
	{ name: 'Cambodia', code: 'KH' },
	{ name: 'Cameroon', code: 'CM' },
	{ name: 'Canada', code: 'CA' },
	{ name: 'Cape Verde', code: 'CV' },
	{ name: 'Cayman Islands', code: 'KY' },
	{ name: 'Central African Republic', code: 'CF' },
	{ name: 'Chad', code: 'TD' },
	{ name: 'Chile', code: 'CL' },
	{ name: 'China', code: 'CN' },
	{ name: 'Christmas Island', code: 'CX' },
	{ name: 'Cocos (Keeling) Islands', code: 'CC' },
	{ name: 'Colombia', code: 'CO' },
	{ name: 'Comoros', code: 'KM' },
	{ name: 'Congo', code: 'CG' },
	{ name: 'Congo, The Democratic Republic of the', code: 'CD' },
	{ name: 'Cook Islands', code: 'CK' },
	{ name: 'Costa Rica', code: 'CR' },
	{ name: "Cote D'Ivoire", code: 'CI' },
	{ name: 'Croatia', code: 'HR' },
	{ name: 'Cuba', code: 'CU' },
	{ name: 'Cyprus', code: 'CY' },
	{ name: 'Czech Republic', code: 'CZ' },
	{ name: 'Denmark', code: 'DK' },
	{ name: 'Djibouti', code: 'DJ' },
	{ name: 'Dominica', code: 'DM' },
	{ name: 'Dominican Republic', code: 'DO' },
	{ name: 'Ecuador', code: 'EC' },
	{ name: 'Egypt', code: 'EG' },
	{ name: 'El Salvador', code: 'SV' },
	{ name: 'Equatorial Guinea', code: 'GQ' },
	{ name: 'Eritrea', code: 'ER' },
	{ name: 'Estonia', code: 'EE' },
	{ name: 'Ethiopia', code: 'ET' },
	{ name: 'Falkland Islands (Malvinas)', code: 'FK' },
	{ name: 'Faroe Islands', code: 'FO' },
	{ name: 'Fiji', code: 'FJ' },
	{ name: 'Finland', code: 'FI' },
	{ name: 'France', code: 'FR' },
	{ name: 'French Guiana', code: 'GF' },
	{ name: 'French Polynesia', code: 'PF' },
	{ name: 'French Southern Territories', code: 'TF' },
	{ name: 'Gabon', code: 'GA' },
	{ name: 'Gambia', code: 'GM' },
	{ name: 'Georgia', code: 'GE' },
	{ name: 'Germany', code: 'DE' },
	{ name: 'Ghana', code: 'GH' },
	{ name: 'Gibraltar', code: 'GI' },
	{ name: 'Greece', code: 'GR' },
	{ name: 'Greenland', code: 'GL' },
	{ name: 'Grenada', code: 'GD' },
	{ name: 'Guadeloupe', code: 'GP' },
	{ name: 'Guam', code: 'GU' },
	{ name: 'Guatemala', code: 'GT' },
	{ name: 'Guernsey', code: 'GG' },
	{ name: 'Guinea', code: 'GN' },
	{ name: 'Guinea-Bissau', code: 'GW' },
	{ name: 'Guyana', code: 'GY' },
	{ name: 'Haiti', code: 'HT' },
	{ name: 'Heard Island and Mcdonald Islands', code: 'HM' },
	{ name: 'Holy See (Vatican City State)', code: 'VA' },
	{ name: 'Honduras', code: 'HN' },
	{ name: 'Hong Kong', code: 'HK' },
	{ name: 'Hungary', code: 'HU' },
	{ name: 'Iceland', code: 'IS' },
	{ name: 'India', code: 'IN' },
	{ name: 'Indonesia', code: 'ID' },
	{ name: 'Iran, Islamic Republic Of', code: 'IR' },
	{ name: 'Iraq', code: 'IQ' },
	{ name: 'Ireland', code: 'IE' },
	{ name: 'Isle of Man', code: 'IM' },
	{ name: 'Israel', code: 'IL' },
	{ name: 'Italy', code: 'IT' },
	{ name: 'Jamaica', code: 'JM' },
	{ name: 'Japan', code: 'JP' },
	{ name: 'Jersey', code: 'JE' },
	{ name: 'Jordan', code: 'JO' },
	{ name: 'Kazakhstan', code: 'KZ' },
	{ name: 'Kenya', code: 'KE' },
	{ name: 'Kiribati', code: 'KI' },
	{ name: "Korea, Democratic People'S Republic of", code: 'KP' },
	{ name: 'Korea, Republic of', code: 'KR' },
	{ name: 'Kuwait', code: 'KW' },
	{ name: 'Kyrgyzstan', code: 'KG' },
	{ name: "Lao People'S Democratic Republic", code: 'LA' },
	{ name: 'Latvia', code: 'LV' },
	{ name: 'Lebanon', code: 'LB' },
	{ name: 'Lesotho', code: 'LS' },
	{ name: 'Liberia', code: 'LR' },
	{ name: 'Libyan Arab Jamahiriya', code: 'LY' },
	{ name: 'Liechtenstein', code: 'LI' },
	{ name: 'Lithuania', code: 'LT' },
	{ name: 'Luxembourg', code: 'LU' },
	{ name: 'Macao', code: 'MO' },
	{ name: 'Macedonia, The Former Yugoslav Republic of', code: 'MK' },
	{ name: 'Madagascar', code: 'MG' },
	{ name: 'Malawi', code: 'MW' },
	{ name: 'Malaysia', code: 'MY' },
	{ name: 'Maldives', code: 'MV' },
	{ name: 'Mali', code: 'ML' },
	{ name: 'Malta', code: 'MT' },
	{ name: 'Marshall Islands', code: 'MH' },
	{ name: 'Martinique', code: 'MQ' },
	{ name: 'Mauritania', code: 'MR' },
	{ name: 'Mauritius', code: 'MU' },
	{ name: 'Mayotte', code: 'YT' },
	{ name: 'Mexico', code: 'MX' },
	{ name: 'Micronesia, Federated States of', code: 'FM' },
	{ name: 'Moldova, Republic of', code: 'MD' },
	{ name: 'Monaco', code: 'MC' },
	{ name: 'Mongolia', code: 'MN' },
	{ name: 'Montserrat', code: 'MS' },
	{ name: 'Morocco', code: 'MA' },
	{ name: 'Mozambique', code: 'MZ' },
	{ name: 'Myanmar', code: 'MM' },
	{ name: 'Namibia', code: 'NA' },
	{ name: 'Nauru', code: 'NR' },
	{ name: 'Nepal', code: 'NP' },
	{ name: 'Netherlands', code: 'NL' },
	{ name: 'Netherlands Antilles', code: 'AN' },
	{ name: 'New Caledonia', code: 'NC' },
	{ name: 'New Zealand', code: 'NZ' },
	{ name: 'Nicaragua', code: 'NI' },
	{ name: 'Niger', code: 'NE' },
	{ name: 'Nigeria', code: 'NG' },
	{ name: 'Niue', code: 'NU' },
	{ name: 'Norfolk Island', code: 'NF' },
	{ name: 'Northern Mariana Islands', code: 'MP' },
	{ name: 'Norway', code: 'NO' },
	{ name: 'Oman', code: 'OM' },
	{ name: 'Pakistan', code: 'PK' },
	{ name: 'Palau', code: 'PW' },
	{ name: 'Palestinian Territory, Occupied', code: 'PS' },
	{ name: 'Panama', code: 'PA' },
	{ name: 'Papua New Guinea', code: 'PG' },
	{ name: 'Paraguay', code: 'PY' },
	{ name: 'Peru', code: 'PE' },
	{ name: 'Philippines', code: 'PH' },
	{ name: 'Pitcairn', code: 'PN' },
	{ name: 'Poland', code: 'PL' },
	{ name: 'Portugal', code: 'PT' },
	{ name: 'Puerto Rico', code: 'PR' },
	{ name: 'Qatar', code: 'QA' },
	{ name: 'Reunion', code: 'RE' },
	{ name: 'Romania', code: 'RO' },
	{ name: 'Russian Federation', code: 'RU' },
	{ name: 'RWANDA', code: 'RW' },
	{ name: 'Saint Helena', code: 'SH' },
	{ name: 'Saint Kitts and Nevis', code: 'KN' },
	{ name: 'Saint Lucia', code: 'LC' },
	{ name: 'Saint Pierre and Miquelon', code: 'PM' },
	{ name: 'Saint Vincent and the Grenadines', code: 'VC' },
	{ name: 'Samoa', code: 'WS' },
	{ name: 'San Marino', code: 'SM' },
	{ name: 'Sao Tome and Principe', code: 'ST' },
	{ name: 'Saudi Arabia', code: 'SA' },
	{ name: 'Senegal', code: 'SN' },
	{ name: 'Serbia and Montenegro', code: 'CS' },
	{ name: 'Seychelles', code: 'SC' },
	{ name: 'Sierra Leone', code: 'SL' },
	{ name: 'Singapore', code: 'SG' },
	{ name: 'Slovakia', code: 'SK' },
	{ name: 'Slovenia', code: 'SI' },
	{ name: 'Solomon Islands', code: 'SB' },
	{ name: 'Somalia', code: 'SO' },
	{ name: 'South Africa', code: 'ZA' },
	{ name: 'South Georgia and the South Sandwich Islands', code: 'GS' },
	{ name: 'Spain', code: 'ES' },
	{ name: 'Sri Lanka', code: 'LK' },
	{ name: 'Sudan', code: 'SD' },
	{ name: 'Suriname', code: 'SR' },
	{ name: 'Svalbard and Jan Mayen', code: 'SJ' },
	{ name: 'Swaziland', code: 'SZ' },
	{ name: 'Sweden', code: 'SE' },
	{ name: 'Switzerland', code: 'CH' },
	{ name: 'Syrian Arab Republic', code: 'SY' },
	{ name: 'Taiwan, Province of China', code: 'TW' },
	{ name: 'Tajikistan', code: 'TJ' },
	{ name: 'Tanzania, United Republic of', code: 'TZ' },
	{ name: 'Thailand', code: 'TH' },
	{ name: 'Timor-Leste', code: 'TL' },
	{ name: 'Togo', code: 'TG' },
	{ name: 'Tokelau', code: 'TK' },
	{ name: 'Tonga', code: 'TO' },
	{ name: 'Trinidad and Tobago', code: 'TT' },
	{ name: 'Tunisia', code: 'TN' },
	{ name: 'Turkey', code: 'TR' },
	{ name: 'Turkmenistan', code: 'TM' },
	{ name: 'Turks and Caicos Islands', code: 'TC' },
	{ name: 'Tuvalu', code: 'TV' },
	{ name: 'Uganda', code: 'UG' },
	{ name: 'Ukraine', code: 'UA' },
	{ name: 'United Arab Emirates', code: 'AE' },
	{ name: 'United Kingdom', code: 'GB' },
	{ name: 'United States', code: 'US' },
	{ name: 'United States Minor Outlying Islands', code: 'UM' },
	{ name: 'Uruguay', code: 'UY' },
	{ name: 'Uzbekistan', code: 'UZ' },
	{ name: 'Vanuatu', code: 'VU' },
	{ name: 'Venezuela', code: 'VE' },
	{ name: 'Viet Nam', code: 'VN' },
	{ name: 'Virgin Islands, British', code: 'VG' },
	{ name: 'Virgin Islands, U.S.', code: 'VI' },
	{ name: 'Wallis and Futuna', code: 'WF' },
	{ name: 'Western Sahara', code: 'EH' },
	{ name: 'Yemen', code: 'YE' },
	{ name: 'Zambia', code: 'ZM' },
	{ name: 'Zimbabwe', code: 'ZW' },
];

export const defaultTimezones = [
	// { Value: '', Text: 'Select timezone...', Selected: false },
	{ Value: 'Morocco Standard Time', Text: '(GMT) Casablanca', Selected: false },
	{
		Value: 'GMT Standard Time',
		Text: '(GMT) Greenwich Mean Time : Dublin, Edinburgh, Lisbon, London',
		Selected: false,
	},
	{
		Value: 'Greenwich Standard Time',
		Text: '(GMT) Monrovia, Reykjavik',
		Selected: false,
	},
	{
		Value: 'W. Europe Standard Time',
		Text: '(GMT+01:00) Amsterdam, Berlin, Bern, Rome, Stockholm, Vienna',
		Selected: false,
	},
	{
		Value: 'Central Europe Standard Time',
		Text: '(GMT+01:00) Belgrade, Bratislava, Budapest, Ljubljana, Prague',
		Selected: false,
	},
	{
		Value: 'Romance Standard Time',
		Text: '(GMT+01:00) Brussels, Copenhagen, Madrid, Paris',
		Selected: false,
	},
	{
		Value: 'Central European Standard Time',
		Text: '(GMT+01:00) Sarajevo, Skopje, Warsaw, Zagreb',
		Selected: false,
	},
	{
		Value: 'W. Central Africa Standard Time',
		Text: '(GMT+01:00) West Central Africa',
		Selected: false,
	},
	{ Value: 'Jordan Standard Time', Text: '(GMT+02:00) Amman', Selected: false },
	{
		Value: 'GTB Standard Time',
		Text: '(GMT+02:00) Athens, Bucharest, Istanbul',
		Selected: false,
	},
	{
		Value: 'Middle East Standard Time',
		Text: '(GMT+02:00) Beirut',
		Selected: false,
	},
	{ Value: 'Egypt Standard Time', Text: '(GMT+02:00) Cairo', Selected: false },
	{
		Value: 'South Africa Standard Time',
		Text: '(GMT+02:00) Harare, Pretoria',
		Selected: false,
	},
	{
		Value: 'FLE Standard Time',
		Text: '(GMT+02:00) Helsinki, Kyiv, Riga, Sofia, Tallinn, Vilnius',
		Selected: false,
	},
	{
		Value: 'Israel Standard Time',
		Text: '(GMT+02:00) Jerusalem',
		Selected: false,
	},
	{
		Value: 'E. Europe Standard Time',
		Text: '(GMT+02:00) Minsk',
		Selected: false,
	},
	{
		Value: 'Namibia Standard Time',
		Text: '(GMT+02:00) Windhoek',
		Selected: false,
	},
	{
		Value: 'Arabic Standard Time',
		Text: '(GMT+03:00) Baghdad',
		Selected: false,
	},
	{
		Value: 'Arab Standard Time',
		Text: '(GMT+03:00) Kuwait, Riyadh',
		Selected: false,
	},
	{
		Value: 'Russian Standard Time',
		Text: '(GMT+03:00) Moscow, St. Petersburg, Volgograd',
		Selected: false,
	},
	{
		Value: 'E. Africa Standard Time',
		Text: '(GMT+03:00) Nairobi',
		Selected: false,
	},
	{
		Value: 'Georgian Standard Time',
		Text: '(GMT+03:00) Tbilisi',
		Selected: false,
	},
	{ Value: 'Iran Standard Time', Text: '(GMT+03:30) Tehran', Selected: false },
	{
		Value: 'Arabian Standard Time',
		Text: '(GMT+04:00) Abu Dhabi, Muscat',
		Selected: false,
	},
	{
		Value: 'Azerbaijan Standard Time',
		Text: '(GMT+04:00) Baku',
		Selected: false,
	},
	{
		Value: 'Mauritius Standard Time',
		Text: '(GMT+04:00) Port Louis',
		Selected: false,
	},
	{
		Value: 'Caucasus Standard Time',
		Text: '(GMT+04:00) Yerevan',
		Selected: false,
	},
	{
		Value: 'Afghanistan Standard Time',
		Text: '(GMT+04:30) Kabul',
		Selected: false,
	},
	{
		Value: 'Ekaterinburg Standard Time',
		Text: '(GMT+05:00) Ekaterinburg',
		Selected: false,
	},
	{
		Value: 'Pakistan Standard Time',
		Text: '(GMT+05:00) Islamabad, Karachi',
		Selected: false,
	},
	{
		Value: 'West Asia Standard Time',
		Text: '(GMT+05:00) Tashkent',
		Selected: false,
	},
	{
		Value: 'India Standard Time',
		Text: '(GMT+05:30) Chennai, Kolkata, Mumbai, New Delhi',
		Selected: false,
	},
	{
		Value: 'Sri Lanka Standard Time',
		Text: '(GMT+05:30) Sri Jayawardenepura',
		Selected: false,
	},
	{
		Value: 'Nepal Standard Time',
		Text: '(GMT+05:45) Kathmandu',
		Selected: false,
	},
	{
		Value: 'N. Central Asia Standard Time',
		Text: '(GMT+06:00) Almaty, Novosibirsk',
		Selected: false,
	},
	{
		Value: 'Central Asia Standard Time',
		Text: '(GMT+06:00) Astana, Dhaka',
		Selected: false,
	},
	{
		Value: 'Myanmar Standard Time',
		Text: '(GMT+06:30) Yangon (Rangoon)',
		Selected: false,
	},
	{
		Value: 'SE Asia Standard Time',
		Text: '(GMT+07:00) Bangkok, Hanoi, Jakarta',
		Selected: false,
	},
	{
		Value: 'North Asia Standard Time',
		Text: '(GMT+07:00) Krasnoyarsk',
		Selected: false,
	},
	{
		Value: 'China Standard Time',
		Text: '(GMT+08:00) Beijing, Chongqing, Hong Kong, Urumqi',
		Selected: false,
	},
	{
		Value: 'North Asia East Standard Time',
		Text: '(GMT+08:00) Irkutsk, Ulaan Bataar',
		Selected: false,
	},
	{
		Value: 'Singapore Standard Time',
		Text: '(GMT+08:00) Kuala Lumpur, Singapore',
		Selected: false,
	},
	{
		Value: 'W. Australia Standard Time',
		Text: '(GMT+08:00) Perth',
		Selected: false,
	},
	{
		Value: 'Taipei Standard Time',
		Text: '(GMT+08:00) Taipei',
		Selected: false,
	},
	{
		Value: 'Tokyo Standard Time',
		Text: '(GMT+09:00) Osaka, Sapporo, Tokyo',
		Selected: false,
	},
	{ Value: 'Korea Standard Time', Text: '(GMT+09:00) Seoul', Selected: false },
	{
		Value: 'Yakutsk Standard Time',
		Text: '(GMT+09:00) Yakutsk',
		Selected: false,
	},
	{
		Value: 'Cen. Australia Standard Time',
		Text: '(GMT+09:30) Adelaide',
		Selected: false,
	},
	{
		Value: 'AUS Central Standard Time',
		Text: '(GMT+09:30) Darwin',
		Selected: false,
	},
	{
		Value: 'E. Australia Standard Time',
		Text: '(GMT+10:00) Brisbane',
		Selected: false,
	},
	{
		Value: 'AUS Eastern Standard Time',
		Text: '(GMT+10:00) Canberra, Melbourne, Sydney',
		Selected: false,
	},
	{
		Value: 'West Pacific Standard Time',
		Text: '(GMT+10:00) Guam, Port Moresby',
		Selected: false,
	},
	{
		Value: 'Tasmania Standard Time',
		Text: '(GMT+10:00) Hobart',
		Selected: false,
	},
	{
		Value: 'Vladivostok Standard Time',
		Text: '(GMT+10:00) Vladivostok',
		Selected: false,
	},
	{
		Value: 'Central Pacific Standard Time',
		Text: '(GMT+11:00) Magadan, Solomon Is., New Caledonia',
		Selected: false,
	},
	{
		Value: 'New Zealand Standard Time',
		Text: '(GMT+12:00) Auckland, Wellington',
		Selected: false,
	},
	{
		Value: 'Fiji Standard Time',
		Text: '(GMT+12:00) Fiji, Kamchatka, Marshall Is.',
		Selected: false,
	},
	{
		Value: 'Tonga Standard Time',
		Text: "(GMT+13:00) Nuku'alofa",
		Selected: false,
	},
	{
		Value: 'Azores Standard Time',
		Text: '(GMT-01:00) Azores',
		Selected: false,
	},
	{
		Value: 'Cape Verde Standard Time',
		Text: '(GMT-01:00) Cape Verde Is.',
		Selected: false,
	},
	{
		Value: 'Mid-Atlantic Standard Time',
		Text: '(GMT-02:00) Mid-Atlantic',
		Selected: false,
	},
	{
		Value: 'E. South America Standard Time',
		Text: '(GMT-03:00) Brasilia',
		Selected: false,
	},
	{
		Value: 'Argentina Standard Time',
		Text: '(GMT-03:00) Buenos Aires',
		Selected: false,
	},
	{
		Value: 'SA Eastern Standard Time',
		Text: '(GMT-03:00) Georgetown',
		Selected: false,
	},
	{
		Value: 'Greenland Standard Time',
		Text: '(GMT-03:00) Greenland',
		Selected: false,
	},
	{
		Value: 'Montevideo Standard Time',
		Text: '(GMT-03:00) Montevideo',
		Selected: false,
	},
	{
		Value: 'Newfoundland Standard Time',
		Text: '(GMT-03:30) Newfoundland',
		Selected: false,
	},
	{
		Value: 'Atlantic Standard Time',
		Text: '(GMT-04:00) Atlantic Time (Canada)',
		Selected: false,
	},
	{
		Value: 'SA Western Standard Time',
		Text: '(GMT-04:00) La Paz',
		Selected: false,
	},
	{
		Value: 'Central Brazilian Standard Time',
		Text: '(GMT-04:00) Manaus',
		Selected: false,
	},
	{
		Value: 'Pacific SA Standard Time',
		Text: '(GMT-04:00) Santiago',
		Selected: false,
	},
	{
		Value: 'Venezuela Standard Time',
		Text: '(GMT-04:30) Caracas',
		Selected: false,
	},
	{
		Value: 'SA Pacific Standard Time',
		Text: '(GMT-05:00) Bogota, Lima, Quito, Rio Branco',
		Selected: false,
	},
	{
		Value: 'Eastern Standard Time',
		Text: '(GMT-05:00) Eastern Time (US & Canada)',
		Selected: false,
	},
	{
		Value: 'US Eastern Standard Time',
		Text: '(GMT-05:00) Indiana (East)',
		Selected: false,
	},
	{
		Value: 'Central America Standard Time',
		Text: '(GMT-06:00) Central America',
		Selected: false,
	},
	{
		Value: 'Central Standard Time',
		Text: '(GMT-06:00) Central Time (US & Canada)',
		Selected: false,
	},
	{
		Value: 'Central Standard Time (Mexico)',
		Text: '(GMT-06:00) Guadalajara, Mexico City, Monterrey',
		Selected: false,
	},
	{
		Value: 'Canada Central Standard Time',
		Text: '(GMT-06:00) Saskatchewan',
		Selected: false,
	},
	{
		Value: 'US Mountain Standard Time',
		Text: '(GMT-07:00) Arizona',
		Selected: false,
	},
	{
		Value: 'Mountain Standard Time (Mexico)',
		Text: '(GMT-07:00) Chihuahua, La Paz, Mazatlan',
		Selected: false,
	},
	{
		Value: 'Mountain Standard Time',
		Text: '(GMT-07:00) Mountain Time (US & Canada)',
		Selected: false,
	},
	{
		Value: 'Pacific Standard Time',
		Text: '(GMT-08:00) Pacific Time (US & Canada)',
		Selected: false,
	},
	{
		Value: 'Pacific Standard Time (Mexico)',
		Text: '(GMT-08:00) Tijuana, Baja California',
		Selected: false,
	},
	{
		Value: 'Alaskan Standard Time',
		Text: '(GMT-09:00) Alaska',
		Selected: false,
	},
	{
		Value: 'Hawaiian Standard Time',
		Text: '(GMT-10:00) Hawaii',
		Selected: false,
	},
	{
		Value: 'Samoa Standard Time',
		Text: '(GMT-11:00) Midway Island, Samoa',
		Selected: false,
	},
	{
		Value: 'Dateline Standard Time',
		Text: '(GMT-12:00) International Date Line West',
		Selected: false,
	},
	// { value: '(GMT-11:00) Pago Pago: Pacific/Pago_Pago' },
	// { value: '(GMT-10:00) Hawaii Time: Pacific/Honolulu' },
	// { value: '(GMT-08:00) Pacific Time: America/Los_Angeles' },
	// { value: '(GMT-08:00) Pacific Time - Tijuana: America/Tijuana' },
	// { value: '(GMT-07:00) Mountain Time: America/Denver' },
	// { value: '(GMT-07:00) Mountain Time - Arizona: America/Phoenix' },
	// {
	//   value: '(GMT-07:00) Mountain Time - Chihuahua}, Mazatlan: America/Mazatlan',
	// },
	// { value: '(GMT-06:00) Central Time: America/Chicago' },
	// { value: '(GMT-06:00) Central Time - Mexico City: America/Mexico_City' },
	// { value: '(GMT-06:00) Central Time - Regina: America/Regina' },
	// { value: '(GMT-06:00) Guatemala: America/Guatemala' },
	// { value: '(GMT-05:00) Bogota: America/Bogota' },
	// { value: '(GMT-05:00) Eastern Time: America/New_York' },
	// { value: '(GMT-05:00) Lima: America/Lima' },
	// { value: '(GMT-04:30) Caracas: America/Caracas' },
	// { value: '(GMT-04:00) Atlantic Time - Halifax: America/Halifax' },
	// { value: '(GMT-04:00) Guyana: America/Guyana' },
	// { value: '(GMT-04:00) La Paz: America/La_Paz' },
	// { value: '(GMT-03:00) Buenos Aires: America/Argentina/Buenos_Aires' },
	// { value: '(GMT-03:00) Godthab: America/Godthab' },
	// { value: '(GMT-03:00) Montevideo: America/Montevideo' },
	// { value: '(GMT-03:30) Newfoundland Time - St. Johns: America/St_Johns' },
	// { value: '(GMT-03:00) Santiago: America/Santiago' },
	// { value: '(GMT-02:00) Sao Paulo: America/Sao_Paulo' },
	// { value: '(GMT-02:00) South Georgia: Atlantic/South_Georgia' },
	// { value: '(GMT-01:00) Azores: Atlantic/Azores' },
	// { value: '(GMT-01:00) Cape Verde: Atlantic/Cape_Verde' },
	// { value: '(GMT+00:00) Casablanca: Africa/Casablanca' },
	// { value: '(GMT+00:00) Dublin: Europe/Dublin' },
	// { value: '(GMT+00:00) Lisbon: Europe/Lisbon' },
	// { value: '(GMT+00:00) London: Europe/London' },
	// { value: '(GMT+00:00) Monrovia: Africa/Monrovia' },
	// { value: '(GMT+01:00) Algiers: Africa/Algiers' },
	// { value: '(GMT+01:00) Amsterdam: Europe/Amsterdam' },
	// { value: '(GMT+01:00) Berlin: Europe/Berlin' },
	// { value: '(GMT+01:00) Brussels: Europe/Brussels' },
	// { value: '(GMT+01:00) Budapest: Europe/Budapest' },
	// { value: '(GMT+01:00) Central European Time - Belgrade: Europe/Belgrade' },
	// { value: '(GMT+01:00) Central European Time - Prague: Europe/Prague' },
	// { value: '(GMT+01:00) Copenhagen: Europe/Copenhagen' },
	// { value: '(GMT+01:00) Madrid: Europe/Madrid' },
	// { value: '(GMT+01:00) Paris: Europe/Paris' },
	// { value: '(GMT+01:00) Rome: Europe/Rome' },
	// { value: '(GMT+01:00) Stockholm: Europe/Stockholm' },
	// { value: '(GMT+01:00) Vienna: Europe/Vienna' },
	// { value: '(GMT+01:00) Warsaw: Europe/Warsaw' },
	// { value: '(GMT+02:00) Athens: Europe/Athens' },
	// { value: '(GMT+02:00) Bucharest: Europe/Bucharest' },
	// { value: '(GMT+02:00) Cairo: Africa/Cairo' },
	// { value: '(GMT+02:00) Jerusalem: Asia/Jerusalem' },
	// { value: '(GMT+02:00) Johannesburg: Africa/Johannesburg' },
	// { value: '(GMT+02:00) Helsinki: Europe/Helsinki' },
	// { value: '(GMT+02:00) Kiev: Europe/Kiev' },
	// { value: '(GMT+02:00) Moscow-01 - Kaliningrad: Europe/Kaliningrad' },
	// { value: '(GMT+02:00) Riga: Europe/Riga' },
	// { value: '(GMT+02:00) Sofia: Europe/Sofia' },
	// { value: '(GMT+02:00) Tallinn: Europe/Tallinn' },
	// { value: '(GMT+02:00) Vilnius: Europe/Vilnius' },
	// { value: '(GMT+03:00) Istanbul: Europe/Istanbul' },
	// { value: '(GMT+03:00) Baghdad: Asia/Baghdad' },
	// { value: '(GMT+03:00) Nairobi: Africa/Nairobi' },
	// { value: '(GMT+03:00) Minsk: Europe/Minsk' },
	// { value: '(GMT+03:00) Riyadh: Asia/Riyadh' },
	// { value: '(GMT+03:00) Moscow+00 - Moscow: Europe/Moscow' },
	// { value: '(GMT+03:30) Tehran: Asia/Tehran' },
	// { value: '(GMT+04:00) Baku: Asia/Baku' },
	// { value: '(GMT+04:00) Moscow+01 - Samara: Europe/Samara' },
	// { value: '(GMT+04:00) Tbilisi: Asia/Tbilisi' },
	// { value: '(GMT+04:00) Yerevan: Asia/Yerevan' },
	// { value: '(GMT+04:30) Kabul: Asia/Kabul' },
	// { value: '(GMT+05:00) Karachi: Asia/Karachi' },
	// { value: '(GMT+05:00) Moscow+02 - Yekaterinburg: Asia/Yekaterinburg' },
	// { value: '(GMT+05:00) Tashkent: Asia/Tashkent' },
	// { value: '(GMT+05:30) Colombo: Asia/Colombo' },
	// { value: '(GMT+06:00) Almaty: Asia/Almaty' },
	// { value: '(GMT+06:00) Dhaka: Asia/Dhaka' },
	// { value: '(GMT+06:30) Rangoon: Asia/Rangoon' },
	// { value: '(GMT+07:00) Bangkok: Asia/Bangkok' },
	// { value: '(GMT+07:00) Jakarta: Asia/Jakarta' },
	// { value: '(GMT+07:00) Moscow+04 - Krasnoyarsk: Asia/Krasnoyarsk' },
	// { value: '(GMT+08:00) China Time - Beijing: Asia/Shanghai' },
	// { value: '(GMT+08:00) Hong Kong: Asia/Hong_Kong' },
	// { value: '(GMT+08:00) Kuala Lumpur: Asia/Kuala_Lumpur' },
	// { value: '(GMT+08:00) Moscow+05 - Irkutsk: Asia/Irkutsk' },
	// { value: '(GMT+08:00) Singapore: Asia/Singapore' },
	// { value: '(GMT+08:00) Taipei: Asia/Taipei' },
	// { value: '(GMT+08:00) Ulaanbaatar: Asia/Ulaanbaatar' },
	// { value: '(GMT+08:00) Western Time - Perth: Australia/Perth' },
	// { value: '(GMT+09:00) Moscow+06 - Yakutsk: Asia/Yakutsk' },
	// { value: '(GMT+09:00) Seoul: Asia/Seoul' },
	// { value: '(GMT+09:00) Tokyo: Asia/Tokyo' },
	// { value: '(GMT+09:30) Central Time - Darwin: Australia/Darwin' },
	// { value: '(GMT+10:00) Eastern Time - Brisbane: Australia/Brisbane' },
	// { value: '(GMT+10:00) Guam: Pacific/Guam' },
	// { value: '(GMT+10:00) Moscow+07 - Magadan: Asia/Magadan' },
	// { value: '(GMT+10:00) Moscow+07 - Yuzhno-Sakhalinsk: Asia/Vladivostok' },
	// { value: '(GMT+10:00) Port Moresby: Pacific/Port_Moresby' },
	// { value: '(GMT+10:30) Central Time - Adelaide: Australia/Adelaide' },
	// { value: '(GMT+11:00) Eastern Time - Hobart: Australia/Hobart' },
	// { value: '(GMT+11:00) Eastern Time - Melbourne}, Sydney: Australia/Sydney' },
	// { value: '(GMT+11:00) Guadalcanal: Pacific/Guadalcanal' },
	// { value: '(GMT+11:00) Noumea: Pacific/Noumea' },
	// { value: '(GMT+12:00) Majuro: Pacific/Majuro' },
	// {
	//   value: '(GMT+12:00) Moscow+09 - Petropavlovsk-Kamchatskiy: Asia/Kamchatka',
	// },
	// { value: '(GMT+13:00) Auckland: Pacific/Auckland' },
	// { value: '(GMT+13:00) Fakaofo: Pacific/Fakaofo' },
	// { value: '(GMT+13:00) Fiji: Pacific/Fiji' },
	// { value: '(GMT+13:00) Tongatapu: Pacific/Tongatapu' },
	// { value: '(GMT+14:00) Apia: Pacific/Apia' },
];

export const TimeZones = [
	{
		Value: 'Pacific Standard Time',
		Text: '(GMT-07:00) Pacific Time (US & Canada)',
		Selected: false,
	},
	{
		Value: 'Central Standard Time',
		Text: '(GMT-05:00) Central Time (US & Canada)',
		Selected: false,
	},
	{
		Value: 'Eastern Standard Time',
		Text: '(GMT-05:00) Eastern Time (US & Canada)',
		Selected: false,
	},
	{
		Value: 'Pakistan Standard Time',
		Text: '(GMT+05:00) Islamabad, Karachi',
		Selected: false,
	},
	{
		Value: 'Mountain Standard Time',
		Text: '(GMT-06:00) Mountain Time (US & Canada)',
		Selected: false,
	},
];
